import {
  collection,
  doc,
  addDoc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp
} from 'firebase/firestore'
import { db } from './index'

/**
 * Firestore collection helpers with type safety
 */

// Collection names
export const COLLECTIONS = {
  USERS: 'users',
  VOICE_NOTES: 'voiceNotes',
  SMS_MESSAGES: 'smsMessages'
}

// Users Collection
export const usersCollection = collection(db, COLLECTIONS.USERS)

export const getUserDoc = (userId) => doc(db, COLLECTIONS.USERS, userId)

export const createUser = async (userId, userData) => {
  await setDoc(getUserDoc(userId), {
    ...userData,
    createdAt: serverTimestamp()
  })
}

export const updateUser = async (userId, updates) => {
  await updateDoc(getUserDoc(userId), {
    ...updates,
    updatedAt: serverTimestamp()
  })
}

export const getUser = async (userId) => {
  const docSnap = await getDoc(getUserDoc(userId))
  return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null
}

// Voice Notes Collection
export const voiceNotesCollection = collection(db, COLLECTIONS.VOICE_NOTES)

export const getVoiceNoteDoc = (noteId) => doc(db, COLLECTIONS.VOICE_NOTES, noteId)

export const createVoiceNote = async (noteData) => {
  const docRef = await addDoc(voiceNotesCollection, {
    ...noteData,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  })
  return docRef.id
}

export const updateVoiceNote = async (noteId, updates) => {
  await updateDoc(getVoiceNoteDoc(noteId), {
    ...updates,
    updatedAt: serverTimestamp()
  })
}

export const getVoiceNote = async (noteId) => {
  const docSnap = await getDoc(getVoiceNoteDoc(noteId))
  return docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null
}

export const getUserVoiceNotes = async (userId, limitCount = 50) => {
  const q = query(
    voiceNotesCollection,
    where('userId', '==', userId),
    orderBy('createdAt', 'desc'),
    limit(limitCount)
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
}

export const getVoiceNotesByStatus = async (userId, status) => {
  const q = query(
    voiceNotesCollection,
    where('userId', '==', userId),
    where('status', '==', status),
    orderBy('createdAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
}

export const deleteVoiceNote = async (noteId) => {
  await deleteDoc(getVoiceNoteDoc(noteId))
}

// SMS Messages Collection
export const smsMessagesCollection = collection(db, COLLECTIONS.SMS_MESSAGES)

export const createSMSMessage = async (messageData) => {
  const docRef = await addDoc(smsMessagesCollection, {
    ...messageData,
    sentAt: serverTimestamp()
  })
  return docRef.id
}

export const getSMSMessagesByVoiceNote = async (voiceNoteId) => {
  const q = query(
    smsMessagesCollection,
    where('voiceNoteId', '==', voiceNoteId),
    orderBy('sentAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
}
